import { useCallback } from 'react';

export const useValidateBundles = () => {
  return useCallback<() => string>(() => {
    return "";
  }, []);
};
